import type { SxProps, Theme } from "@mui/material";

export type SlotStyleProps = { sx?: SxProps<Theme> } & Record<string, unknown>;
type SlotStyleResolver = (ownerState: Record<string, unknown>) => SlotStyleProps;

const isResolver = (override: unknown): override is SlotStyleResolver => typeof override === "function";

const isStyleObject = (override: unknown): override is SlotStyleProps =>
	typeof override === "object" && override !== null;

const combineSx = (baseSx?: SxProps<Theme>, overrideSx?: SxProps<Theme>): SxProps<Theme> =>
	[baseSx, overrideSx].filter(Boolean) as SxProps<Theme>;

const layerOverride = (base: SlotStyleProps, override: SlotStyleProps): SlotStyleProps => ({
	...base,
	...override,
	sx: combineSx(base.sx, override.sx)
});

const mergeSlotProps = (base: SlotStyleProps, override: unknown): SlotStyleProps | SlotStyleResolver => {
	if (isResolver(override)) return override;
	if (isStyleObject(override)) return layerOverride(base, override);
	return base;
};

export default mergeSlotProps;
